import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { MutationCache, QueryClient } from '@tanstack/react-query';

import { ErrorSeverity, handleError } from 'services/errorService';

/*
 Default options [skip for now]
 {
  defaultOptions: {
    queries: {
      staleTime: 0.5 * (60 * 1000), // 30 seconds
      gcTime: 5 * (60 * 1000), // 5 mins
    },
  },
}
*/

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1 * (10 * 1000), // 10 seconds
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
  mutationCache: new MutationCache({
    onError(error, _variables, _context, mutation) {
      // Always log mutation errors, but allow specific mutations to suppress
      // the global fallback toast when they handle user-facing messages
      // themselves.
      const suppressGlobalErrorToast = Boolean(
        (mutation.options.meta as { suppressGlobalErrorToast?: boolean } | undefined)
          ?.suppressGlobalErrorToast
      );
      const hasCustomOnError = typeof mutation.options.onError === 'function';
      const severity =
        hasCustomOnError || suppressGlobalErrorToast ? ErrorSeverity.INFO : ErrorSeverity.CRITICAL;

      handleError(error, severity, {
        source: 'MutationCache',
        operation: mutation.options.mutationKey?.join('.') ?? 'unknown',
      });
    },
  }),
});

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
});
